<template>
  <div>
    <component :is="data.state" :data="data" v-model="setValue" :type="type" />
  </div>
</template>
<script>
export default {
  methods: {},
  components: {
    new: () => import("./new"),
    sent: () => import("./sent"),
    cancel: () => import("./cancel"),
    done: () => import("./done"),
  },
  data: () => ({}),
  props: ["value", "data", "type"],
  computed: {
    setValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style>
</style>
 